import React, { useState, useEffect } from 'react';
import { LogD } from '../../../function/LogLapper';
import { TrendManagementSettingType } from '../TrendGraph/TrendGraph';
import { GetUnitWithClc } from '../GroupSettings/TrendSetting/TrendSetting';
import { GetMeasureClcName, GetVibrationSpecialStringByKindNo } from '../../../Constant';
import { useTranslation } from 'react-i18next';

type Props = {
  setData: TrendManagementSettingType;
  isShowOnChange: (event: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  isRowSelectClick: (index: number) => void;
  isDataSelectOnChange: (event: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  isRowSelectDoubleClick: () => void;
};

const TrendGraphItemInfo: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const isDispLog: boolean = false;
  console.debug([`==TrendGraphItemInfo==`, props.setData]);

  const tableStyle: React.CSSProperties = {
    borderWidth: '1px',
    borderColor: '#aaaaaa',
    borderStyle: 'solid',
    background: `${props.setData.LineColor}`,
    borderCollapse: `collapse`,
    marginLeft: '3px',
    width: '12%',
  };

  const tdStyle = {
    borderWidth: '1px',
    borderColor: '#aaaaaa',
    borderStyle: 'solid',
    background: props.setData.IsRowSelect ? '#ffff00' : '#ffffff',
    paddingLeft: '5px',
  };

  const tdStyleColor = {
    borderWidth: '1px',
    borderColor: '#aaaaaa',
    borderStyle: 'solid',
    background: `${props.setData.LineColor}`,
    paddingLeft: '5px',
  };

  return (
    <table style={tableStyle}>
      <tbody
        onDoubleClick={() => {
          props.isRowSelectDoubleClick();
        }}
      >
        {/**表示有 */}
        <tr>
          <td style={tdStyleColor} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            <input
              type="checkbox"
              checked={props.setData.IsShow}
              onChange={(e) => props.isShowOnChange(e, props.setData.IndexNo)}
            />
          </td>
        </tr>
        {/**計測種別 */}
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {GetVibrationSpecialStringByKindNo(props.setData.Kind, t) === ''
              ? props.setData.MeasureKindName
              : GetVibrationSpecialStringByKindNo(props.setData.Kind, t)}
            &nbsp;
          </td>
        </tr>
        {/**機器番号・機器名称 */}
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.MachineIndex != '0' && props.setData.MachineIndex + props.setData.MachineName}&nbsp;
          </td>
        </tr>
        {/**項目名称 */}
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.ItemName}&nbsp;
          </td>
        </tr>
        <tr>
          {/**演算方法 */}
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {GetMeasureClcName(props.setData.Clc, props.setData.OperationProcess, t)}&nbsp;
          </td>
          {/**単位 */}
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {GetUnitWithClc(
              Number(props.setData.PLCNo),
              props.setData.UnitSymbol,
              props.setData.Clc,
              props.setData.MeasureKindNo,
              props.setData.Kind
            )}
            &nbsp;
          </td>
        </tr>
        {/**異常内容 */}
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.TypeName} &nbsp;
          </td>
        </tr>
        <tr>
          {/**軽故障 */}
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.PLCNo !== '0' ? Number(props.setData.TrendValueUpper).toFixed(4) : ' '}&nbsp;
          </td>
          {/**重故障 */}
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.PLCNo !== '0' ? Number(props.setData.TrendValueUpperLimit).toFixed(4) : ' '}&nbsp;
          </td>
        </tr>
        {/**項目選択 */}
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            <input
              type="checkbox"
              checked={props.setData.IsDataSelect}
              onChange={(e) => props.isDataSelectOnChange(e, props.setData.IndexNo)}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TrendGraphItemInfo;
